<div class="row">
  <div class="col-xs-12 col-12 col-sm-6 col-md-5 form-group">
    <p>Outside click closes the datepicker in this example</p>
    <input class="form-control" placeholder="Datepicker" bsDatepicker [outsideClick]="true">
  </div>
  <div class="col-xs-12 col-12 col-sm-6 col-md-5 form-group">
    <p>Outside click doesn't close the datepicker in this example</p>
    <input class="form-control" placeholder="Datepicker" bsDatepicker [outsideClick]="false">
  </div>
</div>
